module.exports = __webpack_public_path__ + "static/media/bottom_bg.7e3b1168.png";